import { Artwork, OralHistory } from "../../../data/artworks";

type ArtworkOralHistoryProps = {
  selectedArtwork: Artwork;
};

type AudioPlayerProps = {
  src: string;
};

const AudioPlayer = ({ src } : AudioPlayerProps) => {
  return (
    <audio
      id="transcript-audio"
      controls
      controlsList={"nodownload"}
      style={{
        width: '100%',
      }}
    >
      <source src={src} type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  );
};

export const ArtworkOralHistory = ({ selectedArtwork }: ArtworkOralHistoryProps) => {
  const oralHistory : OralHistory = selectedArtwork.oralHistory;
  const transcriptParagraphs = oralHistory.transcript.split("\n").map((paragraph, index) => {
    return (
      <p key={index} className="font-inter-light leading-[22px] mb-5"
      style={{
        paddingTop: index === 0 ? "0px" : "0px",
      }}
      >
        {paragraph}
      </p>
    )
  });

  return (
    <div className="flex flex-col gap-2 pb-20 px-0 pr-5">
      <AudioPlayer src={oralHistory.transcriptPath}/>
      <p className="font-inter-light leading-[22px] pt-[20px]">
        <span className="font-inter-bold">Dance Oral History Project: </span>
        {oralHistory.oralHistoryProjectName}{" "}
      </p>
      <p className="font-inter-light leading-[22px]">
        <span className="font-inter-bold">Conducted by: </span>
        {oralHistory.conductor}{" "}
      </p>
      <p className="font-inter-light leading-[22px]">
        <span className="font-inter-bold">Summary: </span>
        {oralHistory.summary}{" "}
      </p>
      <div style={{
      borderTop: "2px dotted white",
      width: "100%",
      margin: "10px 0",
      opacity: "0.4",
      marginTop: "20px",
      paddingBottom: "20px",
    }} />
      <div className="flex flex-col gap-2 px-0 pr-5">
        <span className="font-inter-bold">Transcript: </span>
        <div>
          {transcriptParagraphs}
        </div>
      </div>
    </div>
  );
};
